import React from 'react';
import { Modal, ModalProps } from 'antd';
import { dataTestIdFromTitle } from 'vl-common/src/utils';

type OptionsModalProps = ModalProps;

export const OptionsModal = ({ destroyOnHidden = true, ...rest }: OptionsModalProps) => (
  <Modal
    centered
    destroyOnHidden={destroyOnHidden}
    {...rest}
    title={rest.title && <div data-testid={dataTestIdFromTitle(rest.title)}>{rest.title}</div>}
  />
);
